export enum LocationAccess {
  Denied = 'denied',
  Granted = 'granted',
  Unavailable = 'unavailable',
}

export interface ILocationAccess {
  access: LocationAccess;
  latitude: number | null;
  longitude: number | null;
}
